import { useState } from "react";
import { styled, applyClassName } from "@glitz/react";
import { useNavigate } from "react-router-dom";
import { GrMenu } from "react-icons/gr";
import { spacing, white, green, darkGreen } from "../theme";
import { useViewport } from "../hooks/useViewport";
import TextInput from "./basic/TextInput";
import CartIcon from "./CartIcon";
import MiniCart from "./MiniCart";
import MobileMenu from "./MobileMenu";
import Categories from "./Categories";

const TopMenu = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isCartOpen, setCartOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { isMobile } = useViewport();
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = searchTerm.trim();
    if (trimmed) {
      navigate(`/sok?q=${encodeURIComponent(trimmed)}`);
      setSearchTerm("");
    }
  };

  return (
    <>
      {/* This bar is a direct child of GlitzProvider (no wrapper), so sticky works against the viewport scroll */}
      <StickyBar className="header-sticky-bar">
        {isMobile ? (
          <MobileInnerWrapper>
            <HamburgerButton onClick={() => setMenuOpen(true)}>
              <MenuIcon />
            </HamburgerButton>
            <Img
              src={`${process.env.PUBLIC_URL || ""}/trirebels_logo.png`}
              alt="Logo"
              onClick={() => navigate("/")}
            />
            <CartIcon onOpen={() => setCartOpen(true)} />
          </MobileInnerWrapper>
        ) : (
          <>
            <InnerWrapper>
              <Img
                src={`${process.env.PUBLIC_URL || ""}/trirebels_logo.png`}
                alt="Logo"
                onClick={() => navigate("/")}
              />
              <CartSpacer />
              <CartIcon onOpen={() => setCartOpen(true)} />
            </InnerWrapper>
            <Categories />
          </>
        )}
      </StickyBar>

      {/* Search row sits below the sticky bar and scrolls with content */}
      {isMobile ? (
        <MobileSearchRow>
          <MobileSearchForm onSubmit={handleSearch}>
            <TextInput
              label=""
              placeholder="Sök..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </MobileSearchForm>
        </MobileSearchRow>
      ) : (
        <SearchRow>
          <SearchForm onSubmit={handleSearch}>
            <TextInput
              label=""
              placeholder="Sök..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchForm>
        </SearchRow>
      )}

      <MiniCart isOpen={isCartOpen} onClose={() => setCartOpen(false)} />
      {isMobile && (
        <MobileMenu isOpen={isMenuOpen} onClose={() => setMenuOpen(false)} />
      )}
    </>
  );
};

const Img = styled.img({
  width: "75px",
  height: "75px",
  objectFit: "cover",
  padding: { xy: spacing.xs },
  cursor: "pointer",
});

const StickyBar = styled.div({
  position: "sticky",
  top: 0,
  width: "100%",
  backgroundColor: white,
  zIndex: 100,
});

const InnerWrapper = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: { x: spacing.s },
});

const CartSpacer = styled.div({
  flex: { grow: 1, shrink: 1, basis: 0 },
});

const MobileInnerWrapper = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: { x: spacing.s, y: spacing.xs },
});

const SearchRow = styled.div({
  backgroundColor: white,
  padding: { x: spacing.s, y: spacing.xs },
  borderBottom: { style: "solid", color: "#eee", width: "1px" },
});

const SearchForm = styled.form({
  display: "flex",
  flex: { grow: 1, shrink: 1, basis: 0 },
  justifyContent: "center",
});

const MobileSearchRow = styled.div({
  backgroundColor: white,
  borderBottom: { style: "solid", color: "#eee", width: "1px" },
});

const MobileSearchForm = styled.form({
  display: "flex",
  padding: { x: spacing.m, bottom: spacing.s },
});

const HamburgerButton = styled.button({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "44px",
  height: "44px",
  border: { xy: { style: "none", width: 0, color: "transparent" } },
  backgroundColor: "transparent",
  cursor: "pointer",
  padding: { xy: 0 },
});

const MenuIcon = styled(applyClassName(GrMenu), {
  fontSize: "26px",
  color: green,
  ":hover": {
    color: darkGreen,
  },
});

export default TopMenu;
